
import React, { useEffect, useState } from "react";
import { Table, Spinner, Button, Form, Nav } from "react-bootstrap";
import axios from "../../constents/axios";

const ReportedQuestions = ({ user }) => {
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [subjects, setSubjects] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState('');
  const [status, setStatus] = useState("1");
  const [pageGroup, setPageGroup] = useState(0);
  const [searchQuestionId, setSearchQuestionId] = useState('');
  const [resolvingId, setResolvingId] = useState(null);

  const limit = 10;
  const pagesPerGroup = 10;

  useEffect(() => {
    const fetchSubjects = async () => {
      try {
        const { data } = await axios.get("/getPremiumSubjects");
        setSubjects(data || []);
      } catch (error) {
        console.error("Error fetching subjects:", error);
        setSubjects([]);
      }
    };
    fetchSubjects();
  }, []);

  useEffect(() => {
    const delay = setTimeout(() => {
      fetchData();
    }, 300);
    return () => clearTimeout(delay);
  }, [searchQuestionId, page, selectedSubject, status]); // eslint-disable-line

  const fetchData = async () => {
    setLoading(true);
    try {
      let url = "";
      if (searchQuestionId) {
        url = `/tests/searchResolvedQuestions/${searchQuestionId}`;
      } else {
        url = status === "1"
          ? `/tests/getUnresolvedQuestions/${page}`
          : `/tests/getResolvedQuestions/${page}`;
        if (selectedSubject) {
          url += `?subject=${encodeURIComponent(selectedSubject)}`;
        }
      }

      const res = await axios.get(url);
      setQuestions(res.data.data || []);
      setTotal(res.data.total || 0);
    } catch (error) {
      console.error("Error fetching reported questions:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleStatusChange = async (questionId) => {
    setResolvingId(questionId);
    try {
      await axios.post(`/tests/statusUpdate`, {
        id: questionId,
        user: user.username,
      }, {
        headers: {
          'autherisation': `V9YlI4AgRJa97h9JT45acmijLliEcCEMnxZLtL7VlnWVETZuitk2MYoj0pCcrmHa`,
        }
      });
      fetchData();
    } catch (error) {
      console.error("Error updating question status:", error);
    } finally {
      setResolvingId(null);
    }
  };

  const totalPages = Math.ceil(total / limit);
  const startPage = pageGroup * pagesPerGroup + 1;
  const endPage = Math.min(startPage + pagesPerGroup - 1, totalPages);

  const pageNumbers = [];
  for (let i = startPage; i <= endPage; i++) pageNumbers.push(i);

  useEffect(() => {
    const newGroup = Math.floor((page - 1) / pagesPerGroup);
    if (newGroup !== pageGroup) setPageGroup(newGroup);
  }, [page]); // eslint-disable-line

  return (
    <div style={{ width: "100%", height: "90vh", overflowY: "auto" }}>
      <h1 style={{ marginLeft: "40px" }}>Reported Questions</h1>
      <span style={{ marginLeft: "40px" }} className="text-muted fs-5">
        (Total {status === "1" ? "Unresolved Questions" : "Resolved Questions"} {selectedSubject ? `in ${selectedSubject}` : ""} : {total})
      </span>

      <Form className="row m-3">
        <Form.Group className="col-md-6 mb-3">
          <Form.Label>Choose Subject</Form.Label>
          <Form.Control as="select" value={selectedSubject} onChange={(e) => {
            setSelectedSubject(e.target.value);
            setPage(1);
          }}>
            <option value="">Select Subject</option>
            {subjects.map((subject, index) => (
              <option key={index} value={subject.subject}>
                {subject.subject}
              </option>
            ))}
          </Form.Control>
        </Form.Group>

        <Nav
          variant="pills"
          className="gap-3 mt-3"
          activeKey={status}
          onSelect={(k) => {
            setStatus(k);
            setPage(1);
            setSearchQuestionId('');
          }}
        >
          <Nav.Item>
            <Nav.Link eventKey="1">Unresolved</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="0">Resolved</Nav.Link>
          </Nav.Item>
        </Nav>

        {status === "0" && (
          <>
            <Form.Group className="col-md-6 mt-3">
              <Form.Label>Search by Question ID</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Question ID"
                value={searchQuestionId}
                onChange={(e) => {
                  setQuestions([]);
                  setSelectedSubject('');
                  setSearchQuestionId(e.target.value);
                  setPage(1);
                }}
              />
            </Form.Group>
            <div className="col-md-2 mt-5">
              <Button variant="secondary" onClick={() => setSearchQuestionId("")}>Clear</Button>
            </div>
          </>
        )}
      </Form>

      {loading ? (
        <div className="text-center p-4">
          <Spinner animation="border" />
        </div>
      ) : (
        <>
          {/* Desktop Table View (only ≥ lg) */}
          <div className="d-none d-lg-block">
            <div className="table-responsive">
              <Table bordered>
                <thead className="text-center">
                  <tr>
                    <th>#</th>
                    <th>Q.No</th>
                    <th>Q.ID</th>
                    <th>Batch ID</th>
                    <th>Test Name</th>
                    <th>Subject</th>
                    <th>Question</th>
                    <th>Issue</th>
                    <th>Issue type</th>
                    <th>Report By</th>
                    <th>Mobile</th>
                    <th>Report Date</th>
                    {status === "0" && <th>Resolved By</th>}
                    {status === "0" && <th>Resolved Date</th>}
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {questions.length > 0 ? questions.map((q, index) => (
                    <tr key={q.question_id + "-" + index} className="text-center">
                      <td style={{ maxWidth: "10px" }}>{(page - 1) * limit + index + 1}</td>
                      <td style={{ maxWidth: "10px" }}>{q.question_number}</td>
                      <td className="q-id" style={{ maxWidth: "10px" }}>{q.question_id}</td>
                      <td style={{ maxWidth: "10px" }}>{q.questions_batch_id}</td>
                      <td className="test-name" style={{ maxWidth: "100px" }}>{q.title} {q.part !== null ? `(${q.part})` : ""}</td>
                      <td className="subject-name" style={{ maxWidth: "100px" }}>{q.subject}</td>
                      <td className="question-cell" dangerouslySetInnerHTML={{ __html: q.question }}></td>
                      <td style={{ maxWidth: "100px" }}>{q.issue_description}</td>
                      <td style={{ maxWidth: "100px" }}>{q.type}</td>
                      <td style={{ maxWidth: "150px", fontSize: "11px" }}>{q.name}</td>
                      <td style={{ maxWidth: "100px", fontSize: "11px" }}>{q.mobile}</td>
                      <td className="issue-css" style={{ maxWidth: "100px" }}>
                        {q.report_date ? new Date(q.report_date).toLocaleString("en-US", {
                          timeZone: "UTC", year: "numeric", month: "2-digit", day: "2-digit",
                          hour: "2-digit", minute: "2-digit", hour12: true
                        }) : '-'}
                      </td>
                      {status === "0" && <td style={{ maxWidth: "150px", fontSize: "11px" }}>{q.resolved_by}</td>}
                      {status === "0" && <td style={{ maxWidth: "100px", fontSize: "11px" }}>
                        {q.resolved_date && new Date(q.resolved_date).toLocaleString() !== "1/1/1970, 5:30:00 AM"
                          ? new Date(q.resolved_date).toLocaleString()
                          : '-'}
                      </td>}
                      <td>
                        {q.status === 1 ? (
                          <div className="d-flex justify-content-center gap-2 mb-2">
                            <a
                              className="btn btn-primary"
                              href={`/EditQuestion/${q.question_id}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              onClick={() => localStorage.setItem("viewButtonClicked", "true")}
                            >
                              View
                            </a>
                            <Button
                              variant="warning"
                              size="sm"
                              onClick={() => handleStatusChange(q.id)}
                              disabled={resolvingId === q.id}
                            >
                              {resolvingId === q.id ? <Spinner size="sm" animation="border" /> : "Resolve"}
                            </Button>
                          </div>
                        ) : q.status === 2 ? (
                          <>
                        <div className="text-white fw-bold text-center mb-2" style={{ backgroundColor: "red", borderRadius: "5px", padding: "5px" }}>Overdue</div>
                        <div className="d-flex justify-content-center gap-2 mb-2">
                            <a
                              className="btn btn-primary"
                              href={`/EditQuestion/${q.question_id}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              onClick={() => localStorage.setItem("viewButtonClicked", "true")}
                              >
                              View
                            </a>
                            <Button
                              variant="warning"
                              size="sm"
                              onClick={() => handleStatusChange(q.id)}
                              disabled={resolvingId === q.id}
                              >
                              {resolvingId === q.id ? <Spinner size="sm" animation="border" /> : "Resolve"}
                            </Button>
                        </div>
                          </>
                        ) : (
                          <div className="text-white fw-bold text-center" style={{ backgroundColor: q.status === 1 ? "red" : "green", borderRadius: "5px", padding: "5px" }}>
                            {q.status === 1 ? "Pending" : "Resolved"}
                          </div>
                        )}
                        {q.already_resolved === 1 && (
                          <div className="text-danger fw-bold" style={{ fontSize: "10px" }}>
                            Already Resolved Question
                          </div>
                        )}
                      </td>
                    </tr>
                  )) : (
                    <tr><td colSpan="100%" className="text-center">No Questions Found</td></tr>
                  )}
                </tbody>
              </Table>
            </div>
          </div>

          {/* Mobile + Tablet View (same cards for < lg) */}
          <div className="d-lg-none px-2">
            {questions.length > 0 ? questions.map((q, index) => (
              <div key={index} className="card mb-3 p-3 shadow-sm">
                <div style={{ display: "flex", justifyContent: "space-between"}}>
                <p><strong>Q.No:</strong> {q.question_number}</p>
                {q.status === 2 && (
                  <div className="text-white text-center" style={{ backgroundColor: "red", borderRadius: "5px", padding: "8px" }}>Overdue</div>
                )}
                </div>
                <p><strong>Q.ID:</strong> {q.question_id}</p>
                <p><strong>Test:</strong> {q.title} {q.part ? `(${q.part})` : ''}</p>
                <p><strong>Subject:</strong> {q.subject}</p>
                <p><strong>Batch ID:</strong> {q.questions_batch_id}</p>
                <p className="question-cell-mobile"><strong>Question:</strong> <span dangerouslySetInnerHTML={{ __html: q.question }} /></p>
                <p><strong>Issue:</strong> {q.issue_description}</p>
                <p><strong>Issue Type:</strong> {q.type}</p>
                <p><strong>Reported By:</strong> {q.name}</p>
                <p><strong>Mobile:</strong> {q.mobile}</p>
                <p>
                  <strong>Report Date:</strong>{" "}
                  {q.report_date ? new Date(q.report_date).toLocaleString("en-US", {
                    timeZone: "UTC", year: "numeric", month: "2-digit", day: "2-digit",
                    hour: "2-digit", minute: "2-digit", hour12: true
                  }) : '-'}
                </p>
                {status === "0" && (
                  <>
                    <p><strong>Resolved By:</strong> {q.resolved_by}</p>
                    <p><strong>Resolved Date:</strong> {q.resolved_date ? new Date(q.resolved_date).toLocaleString() : '-'}</p>
                  </>
                )}
                <div className="d-flex gap-2 flex-wrap mt-2">
                  {q.status === 1 || q.status === 2 ? (
                    <>
                      <a href={`/EditQuestion/${q.question_id}`} target="_blank" rel="noreferrer" className="btn btn-sm btn-primary"
                         onClick={() => localStorage.setItem("viewButtonClicked", "true")}>
                        View
                      </a>
                      <Button variant="warning" size="sm" onClick={() => handleStatusChange(q.id)} disabled={resolvingId === q.id}>
                        {resolvingId === q.id ? <Spinner size="sm" animation="border" /> : "Resolve"}
                      </Button>
                    </>
                  ) : (
                    <span className="badge bg-success">Resolved</span>
                  )}
                </div>
              </div>
            )) : (
              <p className="text-center">No Questions Found</p>
            )}
          </div>

          {/* Pagination */}
          <div className="d-flex justify-content-center align-items-center gap-2 flex-wrap px-3 py-2">
            {pageGroup > 0 && (
              <Button variant="outline-secondary" onClick={() => setPageGroup(pageGroup - 1)}>Prev</Button>
            )}
            {pageNumbers.map((pgNum) => (
              <Button key={pgNum} variant={pgNum === page ? 'primary' : 'outline-primary'} onClick={() => setPage(pgNum)}>{pgNum}</Button>
            ))}
            {endPage < totalPages && (
              <Button variant="outline-secondary" onClick={() => setPageGroup(pageGroup + 1)}>Next</Button>
            )}
          </div>

          {/* CSS */}
          <style>{`
            .question-cell-mobile {
              max-width: 100%;
              white-space: normal;
              word-break: break-word;
            }
            .question-cell {
              max-width: 600px;
              white-space: normal;
              word-break: break-word;
            }
            .question-cell img,
            .question-cell-mobile img {
              max-width: 100%;
              height: auto;
              display: block;
              margin: 5px 0;
            }

            /* Since cards are used up to < lg, no need to force nowrap on table below 992px */
            @media (max-width: 991.98px) {
              .table-responsive { overflow-x: visible; }
              .table th, .table td { white-space: normal; }
            }
          `}</style>
        </>
      )}
    </div>
  );
};

export default ReportedQuestions;

